//* helper methods for processing pdf

export default {
    methods:{
        async processPdfBlob(blob_data){
            if(blob_data.type == 'text/plain'){
                //* remove the base64 header from the blob result
                const b64_string = await blob_data.text();
                const blob_text = b64_string.split(',')[1];
                
                const decoded = window.atob(blob_text);
                let new_blob = new Blob([decoded], {
                    type: 'application/pdf'
                });
                const b64 = await new Response(new_blob).arrayBuffer();
                console.log('CONVERTED FROM text/plain', b64);
                return b64;
            }
            else{
                const b64 = await new Response(blob_data).arrayBuffer();
                console.log('CONVERTED FROM application/pdf', b64);
                return b64;
            }
        },
    }
}